import heroMainImage from '@/assets/landing/hero-main-image.webp'

import {
  HeroContainer,
  HeroIllust,
  HeroSubCopy,
  HeroSubCopyBottom,
  HeroSubCopyTop,
  HeroTitle,
  HeroTitleAccent,
} from './styles'

export function HeroSection() {
  return (
    <HeroContainer>
      <HeroTitle>
        <span>오늘수거 밀봉비닐</span>
        <HeroTitleAccent>무료나눔!</HeroTitleAccent>
      </HeroTitle>
      <HeroIllust
        src={heroMainImage}
        alt='밀봉비닐 제품'
        width={257}
        height={163}
        loading='eager'
        decoding='async'
      />
      <HeroSubCopy>
        <HeroSubCopyTop>냄새 차단용으로 제작했지만 정식 판매가 어려워</HeroSubCopyTop>
        <HeroSubCopyBottom>배송비만 받고 드립니다</HeroSubCopyBottom>
      </HeroSubCopy>
    </HeroContainer>
  )
}
